<template>
  <div class="conmon-top">
    <el-row class="search-title common-table-top" style="margin-top: 20px">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">商户列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <router-link to="/home/wx-payment-add">
          <el-button type="primary" class="add-btn" style="float: right;margin-right:0;">添加</el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
       class="table"
       v-loading="loading"
      :data="tableData">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="handleToAdd">新建</span></div>
        </template>
        <!-- <el-table-column
          prop="id"
          label="ID">
        </el-table-column> -->
        <el-table-column
          prop="mch_id"
          label="商户号">
        </el-table-column>
        <el-table-column
          prop="app_id"
          label="AppID">
        </el-table-column>
         <el-table-column
          prop="nick_name"
          width="150"
          label="公众号">
        </el-table-column>
        <!-- <el-table-column
          prop="key"
          label="秘钥">
        </el-table-column>
        <el-table-column
          prop="cert_path"
          label="证书">
        </el-table-column>
        <el-table-column
          prop="key_path"
          label="证书key">
        </el-table-column> -->
        <!-- <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              inactive-color="#CCCCCC"
              @change="changeWechatpay(scope.row.id, scope.row.status)">
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column
          width="130"
          label="操作">
          <template slot-scope="scope">
            <router-link :to="{ path: '/home/wx-payment-edit' , query: { id: scope.row.id}}">
              <div class="op-link editColor">
                编辑
              </div>
            </router-link>
            <div class="op-link deleteColor" @click='delwechatpay(scope.row.id)'>
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import { payList, changeWechatpay, delwechatpay } from '@/api/customer.js'
export default {
  name: 'wxPayment',
  data () {
    return {
      loading: true,
      hide: true,
      tableData: [],
      page: 1,
      size: 10
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 点击去添加商户
    handleToAdd () {
      router.push('/home/wx-payment-add')
    },
    getData() {
      this.loading = true
      let data = {
        page: this.page,
        size: this.size
      }
      payList(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data)
          this.tableData = res.data.data.list
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 启用状态
    changeWechatpay(id, status) {
      let data = {
        id: id,
        status: status
      }
      changeWechatpay(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data)
          this.getData()
          _g.toastMsg('success', '操作成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    delwechatpay(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          id: id
        }
        delwechatpay(data).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除成功')
            this.getData()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green{
  color: green;
}
.red{
  color: red;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
